import React, { useEffect, useState } from "react"
import { Helmet } from "react-helmet"
import useSiteMetadata from "./SiteMetadata"
import { withPrefix } from "gatsby"
import "../app.scss"
import axios from "axios"
import logo from "../images/logo.png"
import { connect } from "react-redux"
import { LOADER_DONE } from "../state/constants"

const TemplateWrapper = connect(state => state.app.loaderState)(({ id, children, loaderDidHide, ...props }) => {

  // const launchDate = new Date("2022-02-16:00:00")
  // const currentDate = new Date()

  const getCountry = () => {
    // console.log("launch", launchDate)
    // console.log("curr", currentDate)
    axios({
      method: "get",
      url: "https://api.ipregistry.co/?key=88m318xjobqumfqw"
    }).then(response => {
      // console.log(response)
      // console.log(response.data.location.country.name)
      if (response &&
        response.data &&
        response.data.location &&
        response.data.location.country &&
        response.data.location.country.code &&
        response.data.location.country.code === "RO") {
        setTimeout(() => {
          props.dispatch({ type: LOADER_DONE })
        }, 200)
        window.location.href = "https://shop.heidi-chocolate.com/"
      } else if (response &&
        response.data &&
        response.data.location &&
        response.data.location.country &&
        response.data.location.country.code &&
        response.data.location.country.code === "AT") {
        setTimeout(() => {
          props.dispatch({ type: LOADER_DONE })
        }, 200)
        window.location.href = "https://shop.heidi-chocolate.com/at/"
      } else {
        props.dispatch({ type: LOADER_DONE })
      }
    }).catch(() => {
      props.dispatch({ type: LOADER_DONE })
    })
  }

  useEffect(() => {
    // console.log("launch", launchDate)
    // console.log("curr", currentDate)
    // if (currentDate >= launchDate) {
    if (props.loading) getCountry()
    // } else {
    //   props.dispatch({ type: LOADER_DONE })
    // }
  }, [])

  const { title, description } = useSiteMetadata()

  return (
    <div id={id}>
      <Helmet>
        <html lang="en"/>
        <title>{title}</title>
        <meta name="description" content={description}/>

        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href={`${withPrefix("/")}img/apple-touch-icon.png`}
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix("/")}img/favicon-32x32.png`}
          sizes="32x32"
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix("/")}img/favicon-16x16.png`}
          sizes="16x16"
        />

        <link
          rel="mask-icon"
          href={`${withPrefix("/")}img/safari-pinned-tab.svg`}
          color="#ff4400"
        />
        <meta name="theme-color" content="#fff"/>

        <meta property="og:type" content="business.business"/>
        <meta property="og:title" content={title}/>
        <meta property="og:url" content="/"/>
        <meta
          property="og:image"
          content={`${withPrefix("/")}img/og-image.jpg`}
        />
        {typeof window !== "undefined" && window.location.href.includes("de-at") &&
        <meta name="facebook-domain-verification" content="sukspxlmdqhb9a0ff97xv3aa0ldjkw"/>
        }
        {typeof window !== "undefined" && window.location.href.includes("de-at") &&
        <script>
          {`!function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  fbq('init', '2714846578816074');
  fbq('track', 'PageView');`}
        </script>}
        {typeof window !== "undefined" && window.location.href.includes("de-at") &&
        <noscript>
          {`<img height="1" width="1" style="display:none"
                src="https://www.facebook.com/tr?id=2714846578816074&ev=PageView&noscript=1"/>`}
        </noscript>
        }
        <script src="https://code.jquery.com/jquery-3.2.1.js"></script>
        <script src="https://cdn.jsdelivr.net/npm/round-slider@1.6.0/dist/roundslider.min.js"></script>
        <link href="https://cdn.jsdelivr.net/npm/round-slider@1.6.0/dist/roundslider.min.css" rel="stylesheet"/>
      </Helmet>
      <div>
        {props.loading &&
        <div className="app-loader">
          <img src={logo} className="loader-center"/>
        </div>}
        <div className={props.loading ? "app-hidden" : ""}>{children}</div>
      </div>
    </div>
  )
})

export default TemplateWrapper
